import PropTypes from 'prop-types';
import React from 'react';
import 'scss/_loading.scss';

export default function Blockquote(props) {
  return (
    <blockquote
      style={{ margin: '5px', padding: '15px' }}
      className={`custom-blockquote ${props.type}`}
    >
      <div className="row">
        <div className="col" style={{ display: 'flex' }}>
          <span className="k-input-icon">
            <span
              style={{ fontSize: '20px', paddingBottom: '13px' }}
              className={`k-icon k-font-icon k-i-${props.icon}`}
            />
          </span>
          <div style={{ marginTop: '3px' }}>{props.children}</div>
        </div>
      </div>
    </blockquote>
  );
}

Blockquote.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  icon: PropTypes.string,
  type: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.oneOf(['info', 'error', 'none']),
  ]),
};
